export enum UserFunctions {
  Seguridad = 10,
  Seguridad_Consulta = 11,
  Seguridad_Administracion = 12,
  Legos = 20,
  Legos_Visualizar = 21,
  Legos_Editar = 22,
  Legos_Homologar = 23,
  Legos_Administrar = 24
}
